// ----------------------------------------
// Andriy EXTRA STUFF
// ----------------------------------------

$(window).ready(function($) {
  // LooxReviews
  if (window.location.pathname.match(/^(\/collections\/.+)?\/products\/.+$/g)
  || window.location.pathname.match(/^\/collections\/.+$/g)) {
    $(function () {
      var maxTime = 5000, incTime = 200, elapsedTime = 0;
      var timerFunc = setInterval(function () {
        let actualLooxElemCheck = $('.loox-rating span');
        if (actualLooxElemCheck.length === 0) {
          elapsedTime = elapsedTime + incTime;
          if (elapsedTime > maxTime) {
            clearInterval(timerFunc);
            console.log('looxTweak timer: expired');
          }
          return;
        }

        // Got the required element in place (loaded)
        let handleLooxNode = function(looxRootNode){
          let productId = $(looxRootNode).data('id') + '';
          // locate extra digit (by product id)
          let newDigits = function (productId) {
            const rules = [{
              id:    '1234567890', // product-handle-example
              digit: '3&'
            }];
            let index, len;
            for (index = 0, len = rules.length; index < len; ++index) {
              if (rules[index].id === productId) {
                return rules[index].digit;
              }
            }
            return '';
          }(productId);
          // extract extra digit from the node data (will work on a product details page only)
          // let newDigits = $(looxRootNode).data('extra-digits') + '';
          if (newDigits === '' || newDigits === 'undefined') {
            clearInterval(timerFunc);
            console.log('looxTweak timer: no newDigits to work with');
            return;
          }

          // prepend, append or replace?
          let newQty = '';
          if (newDigits.startsWith('&')) {
            // append: "100" + "&26" = 10026
            newQty = $(looxRootNode).data('raters') + newDigits.substring(1);
          }
          else if (newDigits.endsWith('&')) {
            // prepend: "100" + "26&" = 26100
            newQty = newDigits.substring(0, newDigits.length - 1) + $(looxRootNode).data('raters');
          }
          else {
            // replace: "100" + "26" = 26
            newQty = newDigits;
          }

          let textPattern = $(looxRootNode).data('pattern');
          if (!textPattern) {
            textPattern = '([count])';
          }
          let newText = textPattern.replace(/\[count]/g, newQty);
          let looxElem = $(looxRootNode).find('span');
          if (looxElem.length >= 1) {
            $(looxElem[0]).text(newText);
          }

          $(looxRootNode).data('raters', newQty);
          $(looxRootNode).attr('data-raters', newQty);
          let titleAttr = $(looxRootNode).attr('title');
          if (titleAttr) {
            $(looxRootNode).attr('title', titleAttr.replace(/^(.*\()([\d,]+)(\svote.*)$/g, function (match, p1, p2, p3) {
              return p1 + newQty + p3;
            }));
          }
        };
        $('.loox-rating').each(function(){
          handleLooxNode(this);
        });

        clearInterval(timerFunc);
      }, incTime);
    });
  }

  // == BOA (Buy on Amazon)
  function boa_setup() {
      let boa_container = $('#get-on-amazon');
      if (boa_container.length < 1) {
          return;
      }
      // Hide the standard "Add To Cart" button
      let boa_AddToCartButton = $('form.product-form.product-form-product-template');
      if (boa_AddToCartButton.length > 0) {
          $(boa_AddToCartButton).addClass('hide');
      }
      // Show the BOA button instead
      $(boa_container).removeClass('hide');

      // BOA click handler
      $(boa_container).on('click', 'button.boa', function(event) {
        // can optionally report GA event etc. before handling the click.

        const urlToGo = $(this).data('url') || '';
        if (urlToGo) {
            event.preventDefault();
            window.location.assign(urlToGo);
        }
      });
  }
  boa_setup();
});
